import { createPersistedToggle } from "./persisted-toggle";

export const useCableLengthVisibility = createPersistedToggle("twelve-volt:show-cable-length", false);
